import React, { createContext, useContext, useState, ReactNode } from 'react';
import SuccessModal from '../components/SuccessModal';

interface SuccessContextType {
  showSuccess: (message: string, title?: string, autoClose?: boolean) => void;
}

const SuccessContext = createContext<SuccessContextType | undefined>(undefined);

export const useSuccess = () => {
  const context = useContext(SuccessContext);
  if (!context) {
    throw new Error('useSuccess must be used within SuccessProvider');
  }
  return context;
};

interface SuccessProviderProps {
  children: ReactNode;
}

export const SuccessProvider: React.FC<SuccessProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState<string>('');
  const [title, setTitle] = useState<string>('¡Éxito!');
  const [autoClose, setAutoClose] = useState<boolean>(false);

  const showSuccess = (msg: string, msgTitle?: string, shouldAutoClose?: boolean) => {
    setMessage(msg);
    setTitle(msgTitle || '¡Éxito!');
    setAutoClose(shouldAutoClose || false);
    setShowModal(true);
  };

  return (
    <SuccessContext.Provider value={{ showSuccess }}>
      {children}
      <SuccessModal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setMessage('');
          setTitle('¡Éxito!');
          setAutoClose(false);
        }}
        message={message}
        title={title}
        autoClose={autoClose}
      />
    </SuccessContext.Provider>
  );
};
